"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalConfig = void 0;
/**
 * Global Configuration for Numbets.
 *
 * /global collection contains a "config" document that has global configuration options.
 * These all have default values here
 * in the code if the document isn't found.
 *
 * - maxRegisteredPlayers: a cap on the total number of players to be allowed to register
 *
 * The "config" document has a "playerExceptions" sub-collection.  Each document in
 * the sub-collection is named by an email address (e.g., "dev@bitiotic.com") and
 * should contain a single boolean field "allowed"
 */
class GlobalConfig {
    constructor(ctx, firestore) {
        const globalDocs = firestore.makeCollectionRef(ctx, '/global');
        this.cfgDoc = globalDocs.makeDocRef('config');
        this.playerExceptions =
            this.cfgDoc.makeCollectionRef(ctx, 'playerExceptions');
    }
    getMaxGlobalPlayers(_ctx) {
        return this.cfgDoc.get().then(meta => {
            var _a;
            let maxCt;
            if (meta.docExists()) {
                maxCt = (_a = meta.data()) === null || _a === void 0 ? void 0 : _a.maxRegisteredPlayers;
            }
            return maxCt !== null && maxCt !== void 0 ? maxCt : GlobalConfig.DEFAULT_MAX_GLOBAL_PLAYERS;
        });
    }
    /**
     * Check if there is an explicit entry to allow/disallow the given email address.
     */
    getPlayerExceptionEntry(ctx, emailAddress) {
        const exceptionEntry = this.playerExceptions.makeDocRef(emailAddress);
        return exceptionEntry.get().then(meta => {
            var _a;
            return (_a = meta.data()) === null || _a === void 0 ? void 0 : _a.allowed;
        });
    }
}
exports.GlobalConfig = GlobalConfig;
GlobalConfig.DEFAULT_MAX_GLOBAL_PLAYERS = 50;
//# sourceMappingURL=GlobalConfig.js.map